import { useCallback, useContext, useMemo, useState } from 'react';
import { ActiveChatSessionContext } from '@trinity/chat-components/components/Chat/context';
import { ChatContextType } from '@trinity/chat';
import type { ChatContextItem } from '@trinity/chat';
import { HeaderContextContext } from './context';

type Props = {
  children: React.ReactNode;
};

export const ContextSelectorContainer = (props: Props) => {

  const [pendingContextType, setPendingContextType] = useState<ChatContextType>();
  const [pendingEverythingSearch, setPendingEverythingSearch] = useState(false);
  const [pendingContext, setPendingContext] = useState<ChatContextItem | null>(null);
  const session = useContext(ActiveChatSessionContext);

  const displayContextType = useMemo(() => {
    if (pendingContextType) {
      return pendingContextType;
    }
    return session.context.type;
  }, [session.context.type, pendingContextType]);

  const handleCancelPendingSearch = useCallback(() => {
    setPendingContextType(null);
    setPendingEverythingSearch(false);
    setPendingContext(null);
  }, [setPendingContextType, setPendingEverythingSearch, setPendingContext]);

  const handleSetContextType = useCallback((type: ChatContextType) => {
    if (type !== ChatContextType.Agent) {
      // Only agents have subject autocomplete settings
      setPendingContext(null);
    }
    setPendingContextType(type);
  }, [setPendingContextType, setPendingContext]);

  const ctxValue = {
    cancelPendingSearch: handleCancelPendingSearch,
    displayContextType,
    pendingContextType,
    setPendingContextType: handleSetContextType,
    pendingEverythingSearch,
    setPendingEverythingSearch,
    pendingContext,
    setPendingContext,
  };

  return (
    <HeaderContextContext.Provider value={ctxValue}>
      {props.children}
    </HeaderContextContext.Provider>
  );
};